import { Component } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { AccordionVM } from '../accordion/accordion.model';
import { VideosService } from './videos.service';
import { InitScripts } from '../app.constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})
export class VideosComponent {
  videoList = new BehaviorSubject<AccordionVMVideo[]>([]);

  constructor(private videosService: VideosService, public sanitizer: DomSanitizer, private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
    //new InitScripts().loadMeta();
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Mahanubhav Video Gallery | YouTube | sarvadhnya.com",
      "Mahanubhav Panth videos free download, play online, youtube videos, subscribe",
      "Mahanubhav Panth videos, Mahanubhav videos, Mahanubhav Panth videos free download, play online, Chakradhar swami sthan, Mahanubhav songs gallery");

    this.videosService.get().pipe(
      map((root) => {
        return root.map((x: AccordionVM) => ({
          id: x.id,
          title: x.title,
          body: this.sanitizer.bypassSecurityTrustResourceUrl(x.body)
        } as AccordionVMVideo))
      })
    ).subscribe((res: AccordionVMVideo[]) => {
      this.videoList.next(res);
    })
  }
}

export class AccordionVMVideo {
  id = 0;
  title = "";
  body: any;
}